/**
 * The evidence run's video: the fast variant when it exists (with its remapped
 * timeline), else the full recording. Autoplays and seeks to the evidence node.
 *
 * @module features/proofs/components/EvidenceVideo
 */
import React from 'react';
import { VideoPlayerWithTimeline, normalizeRunStatus } from '@chatsdet/ui';
import { API_URL } from '../../../config';
import { NoVideoEmptyState } from '../../workflows/NoVideoEmptyState';
import type { ProofEvidenceRun } from '../types';

type Props = { run: ProofEvidenceRun; nodeId: string | null };

export const EvidenceVideo: React.FC<Props> = ({ run, nodeId }) => {
  const fastTimeline = run.fastVideoStorageKey ? run.fastVideoTimeline : null;
  const storageKey = fastTimeline ? run.fastVideoStorageKey : run.videoStorageKey;
  const entry = nodeId ? fastTimeline?.entries.find((e) => e.nodeId === nodeId) : undefined;
  const seekRequest = React.useMemo(
    () => (entry ? { timeMs: entry.timestampMs, version: 1 } : null),
    [entry]
  );

  if (!storageKey) {
    return (
      <NoVideoEmptyState
        reason={run.noVideoReason}
        isRunning={['running', 'queued'].includes(normalizeRunStatus(run.status))}
      />
    );
  }
  return (
    <VideoPlayerWithTimeline
      posterSrc={null}
      videoSrc={`${API_URL}/videos/${encodeURIComponent(storageKey)}`}
      timeline={fastTimeline}
      alt="Evidence run recording"
      seekRequest={seekRequest}
      autoPlayMuted
      flush
      showFullscreen={false}
      className="w-full"
    />
  );
};
